import Vue from 'vue';
import VueRouter from 'vue-router';
import authenticateRoutes from '@/router/pos/authenticate-routes';
import authenticatedRoutes from '@/router/pos/authenticated-routes';
import publicRoutes from '@/router/pos/public-routes';

import { getAccessToken } from '@/services/axios';

Vue.use(VueRouter);

const posRouter = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        ...publicRoutes,
        ...authenticateRoutes,
        ...authenticatedRoutes,
        {
            path: '/*',
            name: 'NotFound',
            component: () => import(/* webpackChunkName: "portal" */ '@/views/404/Error404.vue'),
        },
    ],
});

posRouter.beforeEach((to, from, next) => {
    const token = getAccessToken();
    const hasMeta = (name: string): boolean => to.matched.some((record) => record.meta[name]);

    if (hasMeta('authenticated') && token == null) {
        next({ name: 'Login' });
    }

    // if (hasMeta('guest') && token != null) {
    //   next({ name: 'Home' });
    // }
    next();
});

export default posRouter;
